export default __webpack_public_path__ + "static/media/pic47.14133056.jpg";